import React, { useEffect, useState } from 'react';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import styles from "./Progress.module.css";

const Progress = () => {
    const [progress, setProgress] = useState(90);
    const maxProgress = 95; // Maximum progress to fill
    const endDate = new Date('2024-11-04').getTime();
    const dailyIncreaseMin = 6; // Minimum daily increase
    const dailyIncreaseMax = 7; // Maximum daily increase

    useEffect(() => {
        const updateProgress = () => {
            const currentDate = new Date().getTime();
            if (currentDate >= endDate || progress >= maxProgress) {
                setProgress(maxProgress); // Stop progress at 95%
                return;
            }
            const dailyIncrease = Math.floor(Math.random() * (dailyIncreaseMax - dailyIncreaseMin + 1) + dailyIncreaseMin);
            setProgress((prev) => Math.min(prev + dailyIncrease, maxProgress)); // Ensure it does not exceed max
        };

        // Set interval to update progress daily (24 hours)
        const interval = setInterval(updateProgress, 24 * 60 * 60 * 1000);

        return () => clearInterval(interval); // Cleanup on component unmount
    }, [progress, endDate]);

    return (
        <div className={styles.progressContainer}>
            <div className={styles.circularProgress}>
                <CircularProgressbar
                    value={progress}
                    styles={buildStyles({
                        textColor: '#f8f2f2',
                        pathColor: '#ffaf22', // Yellow stroke for progress
                        trailColor: '#e2e1eb', // Background color of the circle
                        textSize: '20px',
                        pathTransitionDuration: 0.5, // Smooth transition for filling
                    })}
                />
            </div>
            <div className={styles.progressText}>
                Limited slots. {progress}% Booked
            </div>
        </div>
    );
};

export default Progress;
